export default "__VITE_ASSET__ZHfRbOIX__"